import useSWR from 'swr';
import { endpoints, fetcher } from 'services';
import useMyInfo from './useMyInfo';

const useMain = () => {
  const { info } = useMyInfo();

  const { data: section } = useSWR<any>(info ? endpoints.main.section : null, () =>
    fetcher.main.getSection({}).then(res => {
      return res;
    })
  );

  const sectionList = section?.mainSectionList || [];

  // 각 섹션 코드 존재 여부 확인
  const hasRecom = sectionList.some((s: any) => s.sectionCode === 'RECOM');
  const hasBanner = sectionList.some((s: any) => s.sectionCode === 'BANNER');
  const hasPopul = sectionList.some((s: any) => s.sectionCode === 'POPUL');
  const hasNews = sectionList.some((s: any) => s.sectionCode === 'NEWS');
  const hasEditor = sectionList.some((s: any) => s.sectionCode === 'EDITOR');
  const hasSns = sectionList.some((s: any) => s.sectionCode === 'SNS');
  const hasAds = sectionList.some((s: any) => s.sectionCode === 'ADS');
  const hasBoard = sectionList.some((s: any) => s.sectionCode === 'BOARD');

  // Hero는 섹션 설정과 무관하게 항상 조회 (기존 로직 유지)
  const { data: hero } = useSWR<any>(info ? endpoints.main.hero : null, () =>
    fetcher.main.getHero({}).then(res => {
      return res;
    })
  );

  const { data: recommend } = useSWR<any>(info && hasRecom ? endpoints.main.recommend : null, () =>
    fetcher.main.getRecommend({}).then(res => {
      return res;
    })
  );

  const { data: banner } = useSWR<any>(info && hasBanner ? [endpoints.main.banner, info] : null, () =>
    fetcher.main.getBanner({}).then(res => {
      return res;
    })
  );

  const { data: popularContent } = useSWR<any>(info && hasPopul ? endpoints.main.popularContent : null, () =>
    fetcher.main.getPopularContent({}).then(res => {
      return res;
    })
  );

  const { data: news } = useSWR<any>(info && hasNews ? endpoints.main.news : null, () =>
    fetcher.main.getNews({}).then(res => {
      return res;
    })
  );

  const { data: playList } = useSWR<any>(info && hasEditor ? endpoints.main.playlist : null, () =>
    fetcher.main.getPlayList({}).then(res => {
      return res;
    })
  );

  const { data: sns } = useSWR<any>(info && hasSns ? endpoints.main.sns : null, () =>
    fetcher.main.getSns({}).then(res => {
      return res;
    })
  );

  const { data: ad } = useSWR<any>(info && hasAds ? endpoints.main.ad : null, () =>
    fetcher.main.getAd({}).then(res => {
      return res;
    })
  );

  const { data: board } = useSWR<any>(info && hasBoard ? endpoints.main.board : null, () =>
    fetcher.main.getBoard({}).then(res => {
      return res;
    })
  );

  return {
    ad,
    banner,
    board,
    hero,
    news,
    playList,
    popularContent,
    recommend,
    section,
    sns,
  };
};

export default useMain;
